import PropTypes from "prop-types";
import React, { useEffect, useState, useContext } from "react";
import Swiper from "react-id-swiper";
import BrandLogoOneSingle from "../../components/brand-logo/BrandLogoOneSingle";
import SectionTitleSeven from "../../components/section-title/SectionTitleSeven";
import { AuthContext } from "../../common/Auth"
import BrandLogoEditIcon from "../../pages/brandLogo/BrandLogoEditIcon";

const BrandLogoSliderThree = () => {

  const [bradLogoSettings, setBradLogoSettings] = useState({})
  const { themeSettingsData, logoData } = useContext(AuthContext)
  const [brandLogoId, setBrandLogoId] = useState("")
  useEffect(() => {
    if (themeSettingsData && themeSettingsData.length > 0) {
      themeSettingsData.map((i) => {
        if (i.settingsName === "brandLogoSettings") {
          setBradLogoSettings(i.values[0])
          setBrandLogoId(i?._id)

        }
      })
    }
  }, [themeSettingsData])

  let mb = bradLogoSettings.marginBottom ? bradLogoSettings.marginBottom : "mb-50";
  let mt = bradLogoSettings.marginTop ? bradLogoSettings.marginTop : "mt-50";
  let mr = bradLogoSettings.marginLeft ? bradLogoSettings.marginLeft : "mr-0";
  let ml = bradLogoSettings.marginRight ? bradLogoSettings.marginRight : "ml-0";
  let pb = bradLogoSettings.paddingBottom ? bradLogoSettings.paddingBottom : "pb-0";
  let pt = bradLogoSettings.paddingTop ? bradLogoSettings.paddingTop : "pt-0";
  let pr = bradLogoSettings.paddingLeft ? bradLogoSettings.paddingLeft : "pr-0";
  let pl = bradLogoSettings.paddingRight ? bradLogoSettings.paddingRight : "pl-0";

  let fullSection = bradLogoSettings.fullSection ? "container-fluid" : "container";
  let bgImage = bradLogoSettings?.bgImage ? bradLogoSettings?.bgImage : "";
  let bgColor = bradLogoSettings?.bgColor ? bradLogoSettings?.bgColor : "";
  
  const settings = {
    loop: logoData?.length <= 5 ? false : true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    },
    grabCursor: true,
    breakpoints: {
      1024: {
        slidesPerView: logoData.length >= 5 ? 5 : logoData.length >= 4 ? 4: logoData?.length >= 3 ? 3 : logoData?.length >= 2 ? 2 : 1,
      },
      768: {
        slidesPerView: logoData.length >= 4 ? 4: logoData?.length >= 3 ? 3 : logoData?.length >= 2 ? 2 : 1,
        loop: logoData?.length <= 4 ? false : true,
      },
      640: {
        slidesPerView: logoData?.length >= 3 ? 3 : logoData?.length >= 2 ? 2 : 1,
        loop: logoData?.length <= 3 ? false : true,
      },
      320: {
        slidesPerView: logoData?.length >= 2 ? 2 : 1,
        loop: logoData?.length <= 2 ? false : true,
      }
    }
  };

  return (
    <div
      className={`antera-clients-logo-section-container brand-logo-area section-bgImage ${mt} ${ml} ${mr} ${mb} ${pt} ${pb} ${pl} ${pr}`} style={(bgImage.length > 0 ) ? {backgroundImage:`url(${bgImage})`} : {background:bgColor}}
    >
      <div className={`antera-clients-logo-content-container ${fullSection}`}>
      <div className="edit-inline">
        <BrandLogoEditIcon brandLogoId={brandLogoId} fromEditAction="topBottomSpace" />
      </div>
        <SectionTitleSeven
          titleText={bradLogoSettings.sectionTitle ? bradLogoSettings.sectionTitle : "Our Clients"}
          subTitleText={bradLogoSettings.sectionSubTitle ? bradLogoSettings.sectionSubTitle : ""}
        />
        <div className="antera-clients-logo-content brand-logo-active">
          {logoData.length > 0 && <Swiper {...settings}>
            {logoData &&
              logoData.map((single, key) => {
                return (
                  <BrandLogoOneSingle
                    data={single}
                    key={key}
                    sliderClassName="swiper-slide"
                    spaceBottomClass="mb-30"
                  />
                );
              })}
          </Swiper>}
        </div>
      </div>
    </div>
  );
};

BrandLogoSliderThree.propTypes = {
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string
};

export default BrandLogoSliderThree;
